@if (!this.beneficiary().czyZweryfikowanyEmail) {
  <p-message severity="warn" icon="pi pi-info-circle">
    <p style="color: red">
      <strong
        >Twój adres e-mail ({{ this.beneficiary().email }}) nie jest
        zweryfikowany.</strong
      >
    </p>
    <p style="color: black">
      Aby składać pisma za pośrednictwem platformy eWnioski, musisz
      przeprowadzić weryfikację swojego adresu e-mail.
    </p>
    <p style="color: red">
      W celu weryfikacji adresu e-mail kliknij
      <button
        type="button"
        class="link-button"
        (click)="sendVerificationLink()"
        [disabled]="isSending() || isCooldown()"
        style="font-weight: bold"
      >
        wyślij link weryfikujący
      </button>
      @if (isSending()) {
        <span> (wysyłanie...)</span>
      } @else if (isCooldown()) {
        <span> (możesz wysłać ponownie za {{ cooldownLeft() }} s)</span>
      }
      .
    </p>
  </p-message>
}
